import { useQuery, UnusedSkipTokenOptions } from '@tanstack/react-query'
import {
	GetTrueWalletLogsParams,
	PaginatedTrueWalletTransactionLogsResponse,
} from '@/modules/transaction/types'
import { queryTrueWalletLogsOptions } from './options'

export default function useQueryTrueWalletLogs(
	payload: GetTrueWalletLogsParams,
	options?: UnusedSkipTokenOptions<PaginatedTrueWalletTransactionLogsResponse>,
) {
	return useQuery(queryTrueWalletLogsOptions(payload, options))
}
